import React from 'react';

import {
  SocialsTypes,
  TypesOfSocials,
} from 'components/SocialsPanel/SocialsPanel';
import useOverElement from 'hooks/useOverElement';
import { useCopyStore } from 'store';
import share from 'u9/utils/share';
import { handleMouseEnter, handleMouseLeave } from 'utils/cursorGlobal';

import * as S from './SharePanel.styles';

export interface SharePanelProps {
  socials: SocialsTypes;
  className?: string;
}

const defaultProps: Partial<SharePanelProps> = {};

const SharePanel: React.FunctionComponent<SharePanelProps> = ({
  socials,
  className,
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);
  const [ref] = useOverElement();

  const hoverTextColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  const shareAction = async (
    link: string,
    text = '',
    type: TypesOfSocials,
    summary = ''
  ) => {
    const typeOfSocials = {
      facebook: () => share.facebook(link),
      twitter: () => share.twitter(link, text),
      linkedin: () => share.linkedin(link, text, summary),
    };
    try {
      await typeOfSocials[type]();
    } catch (err) {
      // TODO: Error message if needed
    }
  };

  return (
    <S.ShareListWrapper ref={ref} className={className}>
      <S.Label>{socials.text}:</S.Label>
      <S.SocialWrapper hoverTextColor={hoverTextColor}>
        {socials.socials.map(social => (
          <S.SocialButton
            key={social.title}
            target="_blank"
            onClick={() =>
              shareAction(
                window.location.href,
                socials.text,
                social?.type,
                social?.title
              )
            }
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {social.title}
          </S.SocialButton>
        ))}
      </S.SocialWrapper>
    </S.ShareListWrapper>
  );
};

SharePanel.defaultProps = defaultProps;

export default SharePanel;
